import { Intent, Position, ProgressBar, Toaster } from "@blueprintjs/core"
import axios from "axios"
import React, { useState } from "react"
import { useHost } from "../global/host.global"
import AppToaster from "utils/AppToaster"
import useAuth from "./useAuth"
import { set } from "lodash-es"
const CancelToken = axios.CancelToken
const source = CancelToken.source()
const UploadToast = Toaster.create({
  className: "recipe-toaster",
  position: Position.TOP,
})
const useFileUpload = (foldername, options) => {
  const [files, setFiles] = useState({})
  const { token } = useAuth()
  const { protocol, host, subdomain } = useHost()
  const link = `${protocol}://${host}/services/uploader/`

  async function handleUpload({ target: { files: filesToUpload } }) {
    let filesList = {}
    for (const file of filesToUpload ?? []) {
      set(filesList, [file?.name], { status: "loading", file })
      setFiles(prev => ({
        ...prev,
        [file?.name]: {
          status: "loading",
          file,
        },
      }))

      /** Initialize New Form Object */
      const form = new FormData()
      form.append("file", file)
      form.append("path", foldername ? `${subdomain}/${foldername}` : subdomain)

      try {
        const response = await axios.post(link, form, {
          cancelToken: source.token,
          onUploadProgress: ({ total, loaded }) => {
            const progress = loaded / total
            const percentage = Math.floor(progress * 100)
            UploadToast.show(
              {
                icon: "cloud-upload",
                message: (
                  <>
                    <small>{file?.name}</small>
                    <ProgressBar
                      className="vt-file-upload-progress"
                      intent={
                        percentage < 100 ? Intent.PRIMARY : Intent.SUCCESS
                      }
                      value={percentage / 100}
                    />
                  </>
                ),
                onDismiss: didTimeoutExpire => {
                  if (!didTimeoutExpire) {
                    source.cancel("Upload of file cancelled by user")
                  }
                },

                timeout: percentage < 100 ? 0 : 3000,
              },
              file?.name
            )
          },

          headers: {
            Tenant: subdomain,
            Authorization: `Bearer ${token}`,
          },
        })

        if (response.data.status === "success") {
          set(filesList, [file?.name], {
            status: "uploaded",
            file: file,
            url: response?.data?.url,
          })

          setFiles(prev => ({
            ...prev,
            [file?.name]: {
              status: "uploaded",
              file: prev?.[file?.name]?.file,
              url: response?.data?.url,
            },
          }))
        }
      } catch (err) {
        AppToaster.show({
          message: err.message,
          intent: "danger",
        })
      }
    }

    options && options.onCompleted(filesList)
  }
  return [files, handleUpload]
}

export default useFileUpload
